export const messages = {
  FROM: 'From',
  FREE: 'Free',
  BACK: 'Back',
  Alert: 'Alert',
  OK: 'OK',
  START: 'Start',
  PATHWAY: 'pathway',
  SESSION: 'Session',
  SAVE_ANSWER: 'Save answer',
  CBT_EXAM: 'CBT Exams',
  SUBJECT: 'Subject',
  DELETE_ALERT_MESSAGE: 'Are you sure you want to delete this ?',
  DATA_NOT_FOUND: 'Data not found',
  ACTIVE: 'Active',
  TICKET_ID: 'Ticket ID',
  EDIT_REPORT: 'Edit report',
  VIEW_FEEDBACK: 'View feedback',
  DELETE: 'Delete',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  VIEW: 'View',
  NOTE: 'Note',
  PREMIUM: 'Premium',
  TO: 'To',
  DASHBOARD: 'Dashboard',
  VIDEOS: 'Videos',
  TOPIC: 'Topic',
  BOOK: 'Book',
  TOTAL_VIDEOS: 'Total Videos',
  CHAPTER_READING: 'Chapter Readings',
  FRM_DASHBOARD_PART_1: 'FRM Dashboard - Part 1',
  FRM_DASHBOARD_PART_2: 'FRM Dashboard - Part 2',
  DETAILED_STATS: 'Detailed Stats',
  READ: 'Read',
  REQUEST_SENT_SUCCESSFULLY: 'Your request has been submitted successfully.',
  CHANGE_NOTES: 'Change Notes',
  UNREAD: 'Unread',
  CHANGE_PATHWAY: 'Change Pathway',
  YOU_CAN_SEE:
    'A full progress bar means you have completed all available questions in that specific topic.',
  PERFORMANCE: 'Performance',
  SEPARATE_YOUR_RESULT:
    'Analyze your results by topic and compare them to a user base of over 50,000 candidates.',
  QUESTION_PROGRESS: 'Questions Progress',
  NOTES_PROGRESS: 'Notes Progress',
  MY_SAVED_ITEM_WITH_FLASH_CARD: 'My Saved Items/Flashcards',
  MY_REPORTS: 'My Reports',
  SHEET_NOT_AVAILABLE: ':sheet Not Available',
  GO_TO_MY_LAST_QUESTION_ANSWERED: 'Go to my Last Answered Question ',
  GO_TO_MY_LAST_READ_NOTE: 'Go to my Last read Note ',
  GO_TO_MY_LAST_VIEWED_VIDEO: 'Go to my Last Viewed Video',
  SEND_REQUEST: 'Send Request',
  QUESTION_BANK: 'Question Bank',
  PATHWAY_EXAM: 'Computer-Based Testing (CBT) Exams',
  PATHWAY_NOT_FOUND: 'Pathway not found',
  ADDITIONAL_RESOURCES: 'Additional Resources',
  SELECT_MODE: 'Select Mode Type',
  PRACTICE_MODE: 'Practice Mode',
  REVISION_MODE: 'Revision Mode',
  NOTES: 'Notes',
  RATIO_SHEET: 'Ratio Sheet',
  READ_NOTES: 'Marked as Read',
  UNREAD_NOTES: 'Mark as Read',
  NO_DATA_FOUND: 'No data found',
  DOWNLOAD_QUESTION: 'Download Q',
  DOWNLOAD_NOTE: ' Download Notes',
  FORMULA_SHEET: 'Formula Sheet',
  NOTES_NOT_AVAILABLE: 'Last read note not available',
  VIDEO_NOT_AVAILABLE: 'Last viewed video not available',
  DOWNLOAD_QUESTION_ANSWER: 'Download Q/A',
  CHANGE_TOPIC: 'Change Topic',
  CHANGE_READING: 'Change Reading',
  CHANGE_QUESTION: 'Change Question',
  BACK_TO_SUMMARY: 'Back to Summary',
  PDF_DOWNLOAD_CONTENT_MESSAGE:
    "You successfully initiated your export. You'll receive an email notification when your export is ready to download.",
  READING: 'Reading',
  ACTION: 'Action',
  LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE: 'Last Attempted Question Not Available',
  VIEW_LIST: 'View List',
  BEGIN_CHAPTER: 'Begin Chapter',
  FRM_TOPIC_PART_1: 'FRM Part I - Topics',
  FRM_TOPIC_PART_2: 'FRM Part II - Topics',
  SUBSCRIBE_PRACTICE_QUESTION: 'Subscribe for numberOfQuestion practice questions',
  QUESTION_STATS_SAVED: 'Question stats saved successfully',
  QUESTION_NOT_AVAILABLE_FOR_READING: 'No questions available for this reading',
  NOTES_NOT_AVAILABLE_FOR_READING: 'No notes available for this reading',
  REPORT: 'Report',
  COMMENT: 'Comment',
  QUIZ_ID: 'Quiz ID',
  PLEASE_WAIT: 'Please wait...',
  CANCEL: 'Cancel',
  REPORT_SEND_SUCCESS_MESSAGE: 'Report sent successfully',
  CLOSE: 'Close',
  SUBJECT_CANT_BE_EMPTY: "Subject can't be empty",
  COMMENT_CANT_BE_EMPTY: "Comment can't be empty",
  REPORT_CANT_BE_EMPTY: "Report can't be empty",
  NO_CHOICE_SELECTED: 'No option selected. Please select option before submitting.',
  SELECT_OPTION_ERROR: 'Please select all the options',
  PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER: 'Please subscribe to get access to this chapter',
  CFA1_PREMIUM_POPUP:
    '<div class="modal-info-list"><ul> <li> Extensive Study Notes </li> <li> 40+ Hours of Video Lessons </li> <li> 3,000+ Practice Questions </li><li> 5 Full-Length Mock Exams </li> <li> Unlimited Customizable Quizzes </li> <li> Tutors Answering your Questions via Live Chat</li></ul></div>',
  PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO: 'Please subscribe to get access to this video',
  FRM_CAPSULES_CHAPTER_NAME:
    'Concept Capsules - Concept Capsules for FRM® Exams - Review some important concepts',
  BACK_TO_VIDEOS: 'Back to Videos',
  GO_TO_NOTES: 'Go to Notes',
  FURTHER_HELP: 'I need further help',
  GO_TO_QUESTION_BANK: 'Go to Question Bank',
  REPORT_THIS_VIDEO: "Report this video to analystprep's team for review",
  Download_PDF: 'Download PDF',
  PDF_NOT_AVAILABLE: 'PDF not available for this video',
  PDF_DOWNLOAD_NOT_AVAILABLE:
    'This PDF is not available for download yet. Please try again later.',
  CFA1_2025_PREMIUM_POPUP:
    '<div class="modal-info-list"><ul> <li> Extensive Study Notes </li> <li> 40+ Hours of Video Lessons </li> <li> 3,000+ Practice Questions </li><li> 5 Full-Length Mock Exams </li> <li> Unlimited Customizable Quizzes </li> <li> Tutors Answering your Questions via Live Chat</li></ul></div>',
  QUIZ_PRIORITY: 'You can priorities quiz on the basis of below options.',
  NON_ATTEMPTED_QUIZ: 'Insufficient non-attempted cases available.',
  FILTER_QUIZZES: 'Filter Quizzes',
  NONE: 'No filter',
  NON_ATTEMPTED_CASES: 'Non-attempted cases',
  CASES_NOT_AVAILABLE: 'Insufficient cases available.',
  STUDY_NOTES: 'Study Notes',
  VIDEO_LESSONS: 'Video Lessons',
  QUIZZES: 'Quizzes',
  ESSAY_QUESTION: 'Essay Question',
  CBT_MOCK_EXAM: 'CBT Mock Exams',
  PATHWAY_EXAM_LIST: 'Pathway Exams',
  PATHWAY_SESSION: 'Pathway Session',
  TUTORING: 'Tutoring',
  UPGRADE_ACCOUNT: 'Upgrade Account',
  PACKAGE: 'Package',
  PRICE: 'Price',
  DISCOUNT: 'Discount',
  TOTAL: 'Total',
  ORDER_ID: 'Order ID',
  NAME: 'Name',
  PAYMENT_METHOD: 'Payment Method',
  EMAIL: 'Email',
  CORRECT: 'Correct',
  INCORRECT: 'Incorrect',
  START_STUDY: 'Start Studying',
  GRAPHICAL_INTERPRETATION: 'Graphics Interpretation',
  OPEN_CALCULATOR: 'Open Calculator',
  RATING_THIS_QUESTION: 'Rate this Question',
  TWO_PART_ANALYSIS: 'Two-Part Analysis',
  SAVE_ITEM_DESCRIPTION:
    'Save this item on your dashboard for further review. You will also be able to create a flashcard.',
  QUESTION_SAVED: 'Question saved',
  RATED: 'Rated',
  THANK_YOU_FOR_YOUR_ORDER: 'Thank You for your Order!',
  REPORT_SUBMISSION_FAILED: 'Report submission failed',
  PURCHASE_CONFIRMATION: 'You will also receive confirmation of your purchase via email',
  ORDER_NOT_FOUND:
    "Oops! We couldn't locate any order. It looks like your order is not available in our database. Please check with correct order details.",
  USER_SESSION_NOT_FOUND: 'User session is missing or expired.',
  QUIZ_DATA_FETCH_ERROR: 'Unable to retrieve quiz data. Please try again.',
  QUESTION_NOT_FOUND: 'The requested question does not exist.',
  QUESTION_DETAILS_ERROR: 'Unable to load question details.',
  QUESTION_API_ERROR: 'There was a problem fetching question details.',
  CHECK_ANSWERED_ERROR: 'Could not verify if the question has been answered.',
  QUIZ_FINISHED: 'Quiz Finished',
  ARE_YOU_SURE: 'Are you sure?',
  YES: 'Yes',
  LOADING: 'Loading',
  EMAIL_UNSUBSCRIBED: `You're currently unsubscribed from email. Want back in? `,
  CLICK_TO_RESUBSCRIBE: 'Click here to resubscribe.',
  SAVE_QUESTION:
    'Save this item on your dashboard for further review. You will also be able to create a flashcard.',
  SETTINGS_TITLE: 'Question Bank Settings',
  QUESTION_BANK_MODE_TYPE: 'Question Bank Mode Type',
  PRACTICE_MODE_DESC: 'Used to reattempt questions.',
  REVISION_MODE_DESC: 'Used for learning, shows your last selected choice.',
  MODE_CHANGE_NOTE:
    'Note:  You can switch between modes later using the dropdown menu on the question bank page.',
  SAVE: 'Save',
  QUESTION_MODE_SAVE_SUCCESS: ':mode is now active. Time to sharpen your skills!',
  QUESTION_MODE_SAVE_FAILED: 'Failed to save question mode. Please try again.',
  WEBINARS: 'Live Sessions',
};



// WEBPACK FOOTER //
// ./src/common/messages.js